import React from 'react';
import { contracts, currency, formatDate, getClientName } from '../data';

type ContractsProps = {
  onSelectContract: (id: string) => void;
};

export const Contracts: React.FC<ContractsProps> = ({ onSelectContract }) => (
  <div className="d-flex flex-column gap-4">
    {contracts.map((contract) => (
      <div key={contract.id} className="section-card">
        <div className="d-flex flex-wrap justify-content-between mb-3 gap-3">
          <div>
            <p className="text-uppercase text-muted small mb-1">{getClientName(contract.clientId)}</p>
            <h2 className="h5 mb-0">{contract.name}</h2>
            <p className="text-muted mb-0">Owned by {contract.manager}</p>
          </div>
          <div className="text-end">
            <span className="badge bg-light text-dark me-2">{contract.status}</span>
            <span className="badge bg-primary-subtle text-primary">{contract.health}</span>
            <p className="mb-0 text-muted">
              {formatDate(contract.startDate)} – {formatDate(contract.endDate)}
            </p>
            <p className="fw-semibold mb-0">{currency(contract.value)}</p>
          </div>
        </div>
        <div className="row g-4">
          <div className="col-lg-5">
            <h3 className="h6">Deliverables</h3>
            <ul className="list-group list-group-flush">
              {contract.deliverables.map((item) => (
                <li key={item} className="list-group-item px-0 d-flex align-items-center">
                  <span className="badge bg-success-subtle text-success me-2">✓</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-7">
            <h3 className="h6">Payment terms</h3>
            <div className="table-responsive">
              <table className="table mb-0 align-middle">
                <thead>
                  <tr>
                    <th scope="col">Milestone</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Target date</th>
                    <th scope="col">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {contract.paymentTerms.map((term) => (
                    <tr key={term.label}>
                      <td>
                        <div className="fw-semibold">{term.label}</div>
                        <small className="text-muted">{term.milestone}</small>
                      </td>
                      <td>{currency(term.amount)}</td>
                      <td>{formatDate(term.dueDate)}</td>
                      <td>
                        <span className={`invoice-pill ${term.status === 'Completed' ? 'badge-paid' : 'badge-pending'}`}>
                          {term.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="text-end">
          <button
            className="btn btn-sm btn-outline-primary"
            type="button"
            onClick={() => onSelectContract(contract.id)}
          >
            View details
          </button>
        </div>
      </div>
    ))}
  </div>
);
